<template>
  <v-app class="selecionar-dominio-bg">
    <v-toolbar dark color="primary">
      <img class="logo-sistema" :src="produtoLogo"/>
      <b class="mr-2">USUÁRIO LOGADO:</b>
      <span>{{ usuarioLogado }}</span>
      <v-spacer></v-spacer>
      <v-btn flat @click="logout">Sair</v-btn>
    </v-toolbar>

    <div class="formulario-selecionar-uo">
      <div class="area-interna elevation-1">
        <v-form @submit.prevent="atualizarDominio">
          <v-autocomplete
              v-model="perfilId"
              :label="ehPerfilFornecedor ? 'Fornecedor' : 'Prefeitura'"
              placeholder="Selecione"
              item-text="nomeCliente"
              item-value="chaveCliente"
              :items="perfis"
              :filter="filtroComboAutoComplete"
              v-validate="'required'"
              :error-messages="errors.collect(ehPerfilFornecedor ? 'Fornecedor' : 'Prefeitura')"
          />

          <v-btn
              class="mt-4"
              depressed
              small
              dark
              color="green"
              type="submit"
          >
            OK
          </v-btn>
        </v-form>
      </div>
    </div>
  </v-app>
</template>

<script>
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import store from '@/commons/store'

    export default {
        name: 'SelecionarDominio',
        $_veeValidate: {
            validator: 'new'
        },
        inject: ['$validator'],
        data() {
            return {
                perfilId: null,
                perfis: this.$store.state.perfis,
                redirectUrl: null
            }
        },
        created() {
          const redirectUrl = this.$route.query.redirectUrl
          if (redirectUrl) {
            this.redirectUrl = redirectUrl
          }
        },
        computed: {
            ehPerfilFornecedor() {
                return this.$store.state.loki.user.type === 'EXTERNO'
            },
            produtoLogo() {
                return this.$store.state.loki.product.symbolLogo
            },
            usuarioLogado() {
                return this.$store.state.loki.user.fullName.toUpperCase()
            }
        },
        methods: {
            async atualizarDominio() {
                const validado = await this.$validator._base.validateAll()

                if (!validado) {
                    return
                }

                const perfil = this.getPerfil(this.perfilId)
                const dominioDTO = {
                    dominioClienteId: perfil.chaveCliente,
                    dominioTipo: perfil.tipoCliente
                }

                await this.atualizarSessaoDominio(dominioDTO)
                await this.validarPermissoesLicitante()
                if (this.redirectUrl != null) {
                  this.irParaTelaComRedirecionamento()
                } else {
                  this.irParaTelaBuscaInicial()
                }
            },
            filtroComboAutoComplete(item, queryText) {
                const text = item.nomeCliente.toLowerCase()
                const searchText = queryText.toLowerCase()
                return text.indexOf(searchText) > -1
            },
            getPerfil(dominioClienteId) {
                const indice = this.perfis.findIndex(p => p.chaveCliente === dominioClienteId)
                return this.perfis[indice]
            },
            irParaTelaBuscaInicial() {
                const url = `${window.location.origin}${window.location.pathname}`
                window.location.assign(url)
            },
            irParaTelaComRedirecionamento() {
              window.location.assign(this.redirectUrl)
            },
            logout() {
                const url = this.$store.state.loki.product.logoutUrl
                window.location.assign(url)
            },
            async validarPermissoesLicitante(){
              if(this.ehPerfilFornecedor){
                const authoritiesUser = store.state.loki.user.authorities || []
                const possuiLicitacaoVisualizar = authoritiesUser.find(permissao => permissao.name === 'Licitacao.Visualizar')
                const possuiPropostaAtualizar = authoritiesUser.find(permissao => permissao.name === 'Proposta.Atualizar')

                const perfis = store.state.perfis || []
                const possuiDominioFornecedor = perfis.find(perfil => perfil.tipoCliente === 'FORNECEDOR')
                if (!possuiLicitacaoVisualizar && !possuiPropostaAtualizar && !possuiDominioFornecedor){
                  return
                }
                if (!possuiLicitacaoVisualizar || !possuiPropostaAtualizar || !possuiDominioFornecedor) {
                  console.error('Erro: usuário fornecedor sem permissões básicas para acesso!')
                  await this.atualizarPermissoesFornecedor()
                  await this.buscarUsuarioLogado()
                }
              }
            },
            ...mapActions([
                actionTypes.ATUALIZAR_SESSAO_DOMINIO,
                actionTypes.BUSCAR_USUARIO_LOGADO,
                actionTypes.MANUTENCAO.ATUALIZAR_PERMISSOES_FORNECEDOR
            ])
        }
    }
</script>
<style lang="stylus">
.selecionar-dominio-bg
    background-color #f5f5f5
    min-height 100vh

.formulario-selecionar-uo
    display flex
    justify-content center
    margin-top 100px

.area-interna
    padding 50px
    background-color white
    width 50%
    display block
    text-align center

.logo-sistema
    width 35px
    margin-right 20px
</style>